// Copyright (c) 2016 Deere & Company

import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';
import Facets from '../state/facets';
import {findSelectedObject} from '../../../shared/services/key-matcher';
import {getDefaultState} from '../state';
import pipActions from '../../actions-list';
import userActions from '../../../user/actions-list';

const actions = {
    ...pipActions,
    ...userActions
};
const defaultShowExcluded = 'N';

const readShowExcluded = (state, action) =>
    Facets.update(state, {
        showExcludedFacet: {
            $merge: {
                allowedExcluded: action.data,
                isInitialLoad: false,
                selectedExcluded: findSelectedObject(defaultShowExcluded, action.data)
            }
        }
    });

const resetAllFacets = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.dealerAccounts
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.dealerAccounts
            }
        },
        showExcludedFacet: {
            selectedExcluded: {
                $set: findSelectedObject(defaultShowExcluded, action.excluded)
            }
        }
    });

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const toggleDealerAccountFacetItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const updateShowExcludedFacetItem = (state, action) =>
    Facets.update(state, {
        showExcludedFacet: {
            selectedExcluded: {
                $set: action.selectedExcluded
            }
        }
    });

const initializeDealerAccountItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                isInitialLoad: false,
                selectedDealers: action.allowedDealers
            }
        }
    });
const updateDealers = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

export default (state = getDefaultState().facets, action) => {

    const actionTypes = {
        [actions.READ_SHOW_EXCLUDED_SUCCESS]: readShowExcluded,
        [actions.RESET_LABOR_ADDITIVE_PIP_PRODUCTS_FILTERS]: resetAllFacets,
        [actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.TOGGLE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEMS]: toggleDealerAccountFacetItems,
        [actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_DEALER_ACCOUNT_FACET_ITEM]: updateDealerAccountFacetItem,
        [actions.UPDATE_LABOR_ADDITIVE_PIP_PRODUCTS_SHOW_EXCLUDED_FACET_ITEM]: updateShowExcludedFacetItem,
        [actions.INITIALIZE_LABOR_ADDITIVE_PIP_PRODUCTS_SHOW_EXCLUDED_FACET_ITEM]: initializeDealerAccountItems,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/labor-additive/reducers/facets.js